<template>
  <div>
    <h2 class="title">{{ $t('payment.chose_payment') }}</h2>
    <AmazonPayButton id="first-payment" tabindex="0" />
    <Separator />
    <WireTransferButton @next-step="nextStep" />
    <!-- <Separator />
    <PayPalButtons /> -->
    <Separator v-if="$whitelabel.giftCardSupport" />
    <GiftCard v-if="$whitelabel.giftCardSupport" @next-step="nextStep" @start-over="startOver" />
  </div>
</template>

<script>
import Separator from '@/components/Separator'
// import PayPalButtons from './PayPalButtons'
import AmazonPayButton from './AmazonPayButton'
import WireTransferButton from './WireTransferButton'
import GiftCard from './GiftCard'
export default {
  name: 'PaymentMethod',
  components: {
    Separator,
    // PayPalButtons,
    WireTransferButton,
    AmazonPayButton,
    GiftCard,
  },

  methods: {
    nextStep() {
      this.$emit('next-step')
    },
    startOver() {
      this.$emit('start-over')
    },
  },
  metaInfo() {
    return {
      // link: [{ rel: 'preconnect', href: '//www.paypal.com', crossorigin: 'anonymous' }],
    }
  },
}
</script>

<style scoped lang="sass"></style>
